import { Injectable } from '@angular/core';
declare const angular: any;

@Injectable({
  providedIn: 'root'
})
export class CurrentDocumentService {
  ajsService: any;

  // documentData$ will be set up as an observable using observeOnScope, so it can be observed in the
  // same way as documentData$ in the Angular version of CurrentDocumentService
  documentData$: any;

  constructor() {
    const element = document.querySelectorAll('div[ui-view]');
    const injector = angular.element(element).injector();

    this.ajsService = injector.get('CurrentDocumentService');

    // get $rootScope so that observeOnScope can be called
    const rootScope = injector.get('$rootScope');
    const observeOnScope = injector.get('observeOnScope');

    // set up observable on documentData, which is a service object, similar to https://embed.plnkr.co/plunk/sGx4HH
    this.documentData$ = observeOnScope(rootScope, () => {
      return this.ajsService.documentData;
    });
  }

  /**
   * get the template from the main document - which is the document that the object nav bar is linked to
   */
  public getTemplate() {
    return this.ajsService.getTemplate();
  }

  public setTemplate(template) {
    return this.ajsService.setTemplate(template);
  }

  /**
   * get the document from the main document - which is the document that the object nav bar is linked to
   */
  public getDocument() {
    return this.ajsService.getDocument();
  }

  public setDocument(document) {
    return this.ajsService.setDocument(document);
  }

  /**
   * set showFormAfterCreated. If false, the form will not be navigated to on save
   */
  public setShowFormAfterCreated(showFormAfterCreated) {
    return this.ajsService.documentData.showFormAfterCreated = showFormAfterCreated;
  }
}
